import { Surgery } from 'common/types'

export const formatSurgeryProviderName = (surgery: Surgery): string => {
  const lastName = surgery?.visit?.attendingProvider?.lastName || ''
  const firstNameInitial =
    surgery?.visit?.attendingProvider?.firstName?.charAt(0) || ''

  return `${lastName}, ${firstNameInitial}`
}
